import {createContext} from 'react'
import {noop} from '@github-ui/noop'
import type {BannerInput} from './internal-banner-stack-data-context'

export interface BannerStackActionsContextValue {
  /* Adds a banner to the stack and returns banner id */
  addBanner: (banner: BannerInput) => string
  /* Merges new props into an existing banner, identified by id, without changing its position in the stack */
  updateBanner: (id: string, banner: Partial<BannerInput>) => void
  /* Removes a banner to the stack */
  dismissBanner: (id: string) => void
  /** Removes all banners from the stack */
  dismissAllBanners: () => void
  /** Moves focus to a banner's rendered root element, identified by the id returned from `addBanner`. No-op if the banner isn't currently rendered. */
  focusBanner: (id: string) => void
}

export const BannerStackActionsContext = createContext<BannerStackActionsContextValue>({
  addBanner: () => {
    // No-op default returns a stable placeholder id; real ids are only ever
    // generated inside `BannerStackProvider`.
    return ''
  },
  updateBanner: noop,
  dismissBanner: noop,
  dismissAllBanners: noop,
  focusBanner: noop,
})
